class Parameters {
  constructor (build) {
    this.store_filters = build.storeFilters
    this.product_filters = build.productFilters
    this.store_dimensions = build.storeDimensions
    this.product_dimensions = build.productDimensions
    this.store_product_dimensions = build.storeProductDimensions
    this.date_dimensions = build.dateDimensions
    this.metrics = build.metrics
    this.stock = build.stock
    this.fact = build.fact
    this.date_filters = build.dateFilters
    this.sort = build.sort
    this.limit = build.limit
    this.offset = build.offset
    this.granularity = build.granularity
  }

  static get ParametersBuilder () {
    class ParametersBuilder {
      constructor (limit = 0, offset = 0, dateDimensions = []) {
        this.limit = limit
        this.offset = offset
        this.dateDimensions = dateDimensions
      }

      withStoreFilters (storeFilters) {
        this.storeFilters = storeFilters
        return this
      }

      withProductFilters (productFilters) {
        this.productFilters = productFilters
        return this
      }

      withStoreDimensions (storeDimensions) {
        this.storeDimensions = storeDimensions
        return this
      }

      withProductDimensions (productDimensions) {
        this.productDimensions = productDimensions
        return this
      }

      withStoreProductDimensions (storeProductDimensions) {
        this.storeProductDimensions = storeProductDimensions
        return this
      }

      withDateDimensions (dateDimensions) {
        this.dateDimensions = dateDimensions
        return this
      }

      withMetrics (metrics) {
        this.metrics = metrics
        return this
      }

      withStock (stock) {
        this.stock = stock
        return this
      }

      withFact (fact) {
        this.fact = fact
        return this
      }

      withDateFilters (dateFilters) {
        this.dateFilters = dateFilters
        return this
      }

      withSort (sort) {
        this.sort = sort
        return this
      }

      withGranularity (granularity) {
        this.granularity = granularity.id
        return this
      }

      build () {
        return new Parameters(this)
      }
    }
    return ParametersBuilder
  }
}

export default Parameters



// WEBPACK FOOTER //
// ./src/app/shared/models/Parameters.js